import type { Page, ZoneListQuery } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { ListSearch } from '../../../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import type { ZoneListItem } from '../../../zones.api';

interface ZonesTableProps {
  page: Page<ZoneListItem>;
  columns: TableColumnsType<ZoneListItem>;
  list: ListQueryControls<ZoneListQuery>;
  isRefreshing: boolean;
  /** A click anywhere on a row opens its zone. */
  onOpen: (zone: ZoneListItem) => void;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function ZonesTable({ page, columns, list, isRefreshing, onOpen }: ZonesTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search name or code" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        rowClassName="cursor-pointer"
        onRow={(zone) => ({ onClick: () => onOpen(zone) })}
        locale={list.isFiltered ? { emptyText: <NoMatchingZones /> } : undefined}
        {...list.tableProps<ZoneListItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingZones() {
  return <EmptyState icon={SearchX} title="No matching zones" description="No zones match this search or these filters." />;
}
